import styled from 'styled-components';

// Horizontal Nav for off-screen horizontal scrolling (categories nav)
export const HorizontalNav = styled.div`
    background: ${props => props.background};
    padding 0 15px;
    overflow-x: scroll;
    overflow-y: hidden;
    display: flex;
    white-space: ${props => props.nowrap};
    &::-webkit-scrollbar {
        display: none;
    }
`;